module.exports = __webpack_public_path__ + "static/onlylegturtle_desktop-ecc2872da3e88ee3e301e5d65ee56786.png";